var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.79 2.644a.879.879 0 00-.645-.283h-.94V.591H2.798v1.77h-.943a.875.875 0 00-.873.944A6.027 6.027 0 003.28 7.56 4.208 4.208 0 006.3 9.748v1.713h1.4V9.748a4.208 4.208 0 003.022-2.19 6.027 6.027 0 002.295-4.253.873.873 0 00-.227-.66zm-10.935.592h.943v2.368c0 .07.002.138.005.207a5.145 5.145 0 01-.948-2.575zm9.343 2.573a4.55 4.55 0 00.005-.205V3.236h.941A5.145 5.145 0 0111.2 5.81zm-6.762 6.413a.875.875 0 00-.875.875v.728c0 .096.078.175.175.175h6.53a.175.175 0 00.175-.175v-.728a.875.875 0 00-.875-.875h-5.13z",
    fill: "#FCBF28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.11 0H2.892a.702.702 0 000 1.403h8.22a.702.702 0 100-1.403zM8.33 11.407H5.672a.815.815 0 00-.815.815h4.286a.815.815 0 00-.815-.815z",
    fill: "#FF934A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.109 4.353L7.983 4.25a.257.257 0 01-.206-.14l-.6-1.195a.257.257 0 00-.465.01L6.19 4.1a.257.257 0 01-.21.151l-1.11.102a.257.257 0 00-.125.464l.856.613a.257.257 0 01.092.297l-.4 1.088a.257.257 0 00.36.316l1.18-.618a.257.257 0 01.235-.002l1.249.63a.257.257 0 00.355-.321l-.416-1.088a.257.257 0 01.094-.303l.882-.61a.257.257 0 00-.123-.466z",
    fill: "#FFF"
  }))));
}

export default SvgTrophy;